// core version + navigation, pagination modules:
import Swiper, { Autoplay } from 'imports/swiper'
let home = {
    swiperBig:null,
    init: function () {
        home.swiperBig  = new Swiper("#home-swiper-hook", {
            modules: [Autoplay],
            init:false,
            loop: true,
            centeredSlides: true,
            spaceBetween: 0,
            slidesPerView: 1,
            autoplay: {
                delay: 4000,
            },
        })
        home.swiperBig.on('transitionEnd', function (e) {
            let index = e.realIndex
            $('.mobile-films .sidenav-links .index').removeClass('active')
            $('.mobile-films .sidenav-links .index-'+index).addClass('active')
        })
        home.swiperBig.on('afterInit', function (e) {
            $('.mobile-films .sidenav-links .index-0').addClass('active')
            $('.mobile-films .sidenav-links .index-0').attr('wtf',1)
        })
        home.swiperBig.init()

        // click on bgimg to go to link
        $('.bgimg').on('click', function(){
            let link = $(this).attr('data-link')
            if(link){
                window.location.href = link
            }
        })
    }


}
export default home
